import { trigger } from '@angular/animations';
import { LowerCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { maxHeightIf } from '../../../animations/max-height.if.animation';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { OnGetData } from '../../../services/dialog.service';
import { websiteHeaderStructure } from '../../../website-header-structure';
import { SvgComponent } from '../../components/svg/svg.component';
import { ButtonDirective } from '../../directives/button.directive';

@Component({
  selector: 'app-website-mobile-menu',
  templateUrl: './website-mobile-menu.component.html',
  styleUrls: ['./website-mobile-menu.component.scss'],
  animations: [trigger('featuresMenu', maxHeightIf(220))],
  standalone: true,
  imports: [ButtonDirective, SvgComponent, RouterLink, LowerCasePipe],
})
export class WebsiteMobileMenuComponent implements OnGetData {
  dialogName = 'website-mobile-menu';
  close: (...args) => void;
  featuresMenuOpen = false;
  menuStructure = websiteHeaderStructure;
  dropdownStates = {};

  dialogOptions(): DialogOptions {
    return { mobileAlignment: 'top' };
  }

  onGetData(data: unknown, close: (...args) => void) {
    this.close = close;
  }
}
